import { render, staticRenderFns } from "./AddBolModal.vue?vue&type=template&id=72fe6059"
import script from "./AddBolModal.vue?vue&type=script&lang=js"
export * from "./AddBolModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports